import FuneralCoverItemRow from './FuneralCoverItemRow'

export default FuneralCoverItemRow
